import React from "react";
import { CheckCircleIcon as CheckCircleIconSolid } from "@heroicons/react/solid";

const ModalMPSEventRegistrationSuccess = ({
  handleClose,
  handleGoToDashboard,
  handleShareEvent,
  eventName
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="w-full max-w-md mx-4 p-8 bg-white shadow-xl rounded-2xl text-center">
        <div className="flex justify-center mb-4">
          <div className="h-20 w-20 rounded-full bg-green-50 flex items-center justify-center">
            <CheckCircleIconSolid className="h-12 w-12 text-green-600" />
          </div>
        </div>
        <h2 className="text-xl font-semibold text-grey-900 mb-2">
          Application Submitted!
        </h2>
        <p className="text-sm text-grey-600 mb-2">
          You've applied to <span className="font-medium text-grey-800">{eventName}</span>.
        </p>
        <p className="text-sm text-grey-500 mb-8">
          The organizer will review your application and you'll receive an email with next steps within 48 hours.
        </p>
        <button
          className="w-full px-4 py-3 text-base font-semibold rounded-lg bg-primary-600 hover:bg-primary-700 text-white transition-colors"
          onClick={handleGoToDashboard}
        >
          View My Applications
        </button>
      </div>
    </div>
  );
};
export default ModalMPSEventRegistrationSuccess;
